'use strict';

var React = require('react'),
    ContentEditable = require('../atoms/ContentEditable'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

require('./ImageCaption.less');

var ImageCaption = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    onChange: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired
  },

  className: 'editor-ImageCaption',

  getInitialState() {
    return {
      isCaptionActive: false
    };
  },

  getCSSModifiers() {
    return [
      this.state.isCaptionActive && 'active',
      !this.props.text && 'empty'
    ];
  },

  render() {
    return (
      <div className={this.getClassName()}>
        {this.props.children}

        <ContentEditable className='editor-ImageCaption-input'
                         text={this.props.text}
                         placeholder='Add optional caption'
                         onChange={this.props.onChange}
                         onFocus={this.handeCaptionFocus}
                         onBlur={this.handeCaptionBlur}
                         onMouseDown={this.handleMouseDown}
                         editable />
      </div>
    );
  },

  handleMouseDown(e) {
    if (!this.state.isCaptionActive) {
      e.preventDefault();
      e.target.focus();
    }
  },

  handeCaptionFocus() {
    this.setState({ isCaptionActive: true });
  },

  handeCaptionBlur() {
    this.setState({ isCaptionActive: false });
  }
});

module.exports = ImageCaption;



/** WEBPACK FOOTER **
 ** ./editor/ImageCaption.jsx
 **/